
import * as d3 from "../lib/d3.js";

const table = JSON.parse(d3.select("#translations").text());

export function tr(key) {
    return table[key] ?? key;
}
